import { createStyles, Paper, Stepper, StepperProps } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import React from 'react';

import { FulfillmentStatusType as OrgsFulfillmentStatusType } from '@portals/api/organizations';
import { FulfillmentStatusType as PartnersFulfillmentStatusType } from '@portals/api/partners';

type FulfillmentStatusType =
  | PartnersFulfillmentStatusType
  | OrgsFulfillmentStatusType;

export const STATUS_TO_INDEX_MAP: Record<FulfillmentStatusType, number> = {
  order_placed: 0,
  missing_information: 0,

  processing: 1,

  ready: 2,

  shipped: 3,

  delivered: 5,
  available: 5,
};

export interface OrderShipmentProgressProps {
  value: PartnersFulfillmentStatusType | OrgsFulfillmentStatusType;
}

export function OrderShipmentProgress({ value }: OrderShipmentProgressProps) {
  const { classes, theme } = useStyles();
  const isSmallerThanMd = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  return (
    <Paper className={classes.container} withBorder radius="md">
      <Stepper
        active={STATUS_TO_INDEX_MAP[value]}
        orientation={isSmallerThanMd ? 'vertical' : 'horizontal'}
        styles={
          isSmallerThanMd ? stepperVerticalStyles : stepperHorizontalStyles
        }
      >
        <Stepper.Step
          label="Order placed"
          data-testid="order-placed-progress-processing-step"
        />
        <Stepper.Step
          label="Processing"
          data-testid="order-shipment-progress-processing-step"
        />
        <Stepper.Step
          label="Shipment Ready"
          data-testid="order-shipment-progress-ready-for-shipment-step"
        />
        <Stepper.Step
          label="Shipped"
          data-testid="order-shipment-progress-ready-shipped-step"
        />
        <Stepper.Step
          label="Delivered"
          data-testid="order-shipment-progress-delivered-step"
        />
      </Stepper>
    </Paper>
  );
}

const stepperHorizontalStyles: StepperProps['styles'] = (theme) => ({
  steps: {
    alignItems: 'flex-start',
  },
  step: {
    flexDirection: 'column',
    cursor: 'default !important',
    gap: theme.spacing.xs,
  },
  separator: {
    margin: 0,
    // stepIcon height is 34px, so we need to move separator to the middle of the icon to make it look centered vertically
    transform: 'translateY(17px)',
  },
  stepBody: {
    margin: 0,
  },
});

const stepperVerticalStyles: StepperProps['styles'] = () => ({
  stepBody: {
    transform: 'translateY(12px)',
  },
});

const useStyles = createStyles((theme) => ({
  container: {
    paddingInline: 100,
    paddingBlock: theme.spacing.xl,

    [theme.fn.smallerThan('md')]: {
      paddingInline: theme.spacing.xl,
    },
  },
}));
